//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Layout2d.js";
import "../no/DisplayableObject.js";
import "../no/ugmath.js";
let d=[[[0,"IsActive",0,0],[0,"LockUpdateStatus",1,0],[0,"UpgradeUponActivation",1,0]],[[[],"Activate",{},0,0],[[],"Deactivate",{},0,0],[[],"Update",{},0,0],[[],"ExitActivate",{},0,0],[["memberType","membersCount","members"],"GetMembers",{},1,0],[["rotation","translation"],"Transform",{},2,0],[["rotation","translation"],"SetTransform",{},2,0],[["rotation","translation"],"GetTransform",{},0,0],[["curves"],"AddExistingCurves",{},1,0],[[],"GetDefinition",{R_:{definition:"Layout2d.ComponentDefinition"}},0,0],[["anchorPoint"],"GetAnchorPoint",{R_:{isAnchorPointExist:''}},0,0],[[],"GetDefinitionName",{R_:{definitionName:''}},0,0],[[],"GetDefinitionPath",{R_:{definitionPath:''}},0,0],[[],"GetDefinitionLocation",{R_:{location:''}},0,0],[[],"ActivateInIsolation",{R_:{internalSketch:"Sketch"}},0,0],[[],"RenewSketch",{},0,0]],[]];
SPLM.Layout2d.Component = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Layout2d.Component";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;